import { useContext } from 'react';
import { UserContext } from '../../context';
import { Page, PageTitle } from '../../components';
import { isHomeowner } from '../../helpers';
import { MFASettings } from './mfa-settings';

export const UserSettings = () => {
  const { user } = useContext(UserContext);
  return (
    <Page
      title={`User Settings - ${user.userName}`}
      showSideNav={!isHomeowner(user)}
      disableDesktopCollapse={isHomeowner(user)}
    >
      <PageTitle title={`User Settings - ${user.userName}`} />
      <MFASettings />
    </Page>
  );
};
